import { message } from 'antd';
import Transaction from './Transaction'
import { connect } from 'react-redux'
import { reduxForm, submit, change, getFormValues } from 'redux-form'
import { push } from 'react-router-redux'
import moment from 'moment'
import { createTransaction, onSelectPurpose } from './actions'
import onMount from '../core/onMount'
import {defaultExpenseCategories} from '../core/CategoryPicker/categories'
import {getPurposes} from './reducer'
import {validate} from './'

const mapStateToProps = (state, ownProps) => {
  const transactionForm = getFormValues('transaction')(state)
  const {transactionType} = ownProps.match.params
  const getPurposeFromLast = ({models}) =>
    models.transactions[0] ?
    {
      income_source: models.transactions[0].income_source,
      purpose: models.transactions[0].purpose
    } : {
      income_source: null,
      purpose: 'Work'
    }

  if (transactionType=='expense') return {
    isExpense: true,
    // if expense, show fields Category and Merchant

    // categories: user.custom_expense_categories + default list
    categories: [
      // ...state.models.user.custom_expense_categories,
      ...defaultExpenseCategories
    ],

    merchants: ['merchant_A', 'merchant_B'],

    title: `New Expense`,

    buttonTitle: 'Save',

    initialValues: {
      ...getPurposeFromLast(state),
      date: new Date()
    },
    purposes: getPurposes(state),
    date: transactionForm && transactionForm.date || new Date(),
    categorySelectValue: transactionForm && transactionForm.category,
    purposeSelectValue: (transactionForm && transactionForm.income_source)
      || (transactionForm && transactionForm.purpose),
    photo: transactionForm && transactionForm.photo,
  }

  if (transactionType=='revenue') return {
    // if expense, show fields Category and Merchant
    // categories: (type==expense) ? [...categoryData] : null,
    // merchants: (type==expense) ? [] : null,

    title: `New Revenue`,
    buttonTitle: 'Save',
    initialValues: {
      category: 'Revenue',
      date: new Date(),
      ...getPurposeFromLast(state),
    },
    purposes: getPurposes(state),
    categories: null,
    merchants: null,
    date: transactionForm && transactionForm.date || new Date(),

    purposeSelectValue: (transactionForm && transactionForm.income_source)
      || (transactionForm && transactionForm.purpose),
    photo: transactionForm && transactionForm.photo,


  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onDateChange: (date)=> date && date.isValid() && dispatch(change('transaction', 'date', moment(date).format('MMM DD, YYYY'))),
    // onSelectCategory: (category)=> console.log({category}),
    onSelectCategory: (category)=> {
      if (category.trim()=='') return
      dispatch(change('transaction', 'category', category))
    },
    save: ()=> dispatch(submit('transaction')),
    // on save, also put/users/me
    // which will then show the custom_expense_categories [] with a pin
    // on save, if revenue, category: 'Revenue'
    onSelectPurpose: (purpose)=> dispatch(onSelectPurpose(purpose)),
    onUpload: (file)=> {
      dispatch(change('transaction', 'photo_attributes', file))
      dispatch(change('transaction', 'photo', null))
    },
    dispatch,
    ownProps
  }
}
const Create = reduxForm({
  form: 'transaction',
  validate,
  onSubmit: (values, dispatch)=> dispatch(createTransaction(values))
    .then(()=>message.success('Created new transaction successfully.', 10))
    .then(()=> dispatch(push(`/transactions`)) ),

})(Transaction)

// const MountedCreate = onMount(({dispatch, ownProps}) => dispatch({type: '...'}) )(Create)

export default connect(mapStateToProps, mapDispatchToProps)(Create)



// WEBPACK FOOTER //
// ./src/transactions/Create.js